/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PersonaResDto } from '../../models/persona-res-dto';

export interface PersoneControllerDeletePersona$Params {
  idPersona: number;
}

export function personeControllerDeletePersona(
  http: HttpClient,
  rootUrl: string,
  params: PersoneControllerDeletePersona$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<PersonaResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    personeControllerDeletePersona.PATH,
    'delete',
  );
  if (params) {
    rb.path('idPersona', params.idPersona, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PersonaResDto>;
      }),
    );
}

personeControllerDeletePersona.PATH = '/admin/persona/id/{idPersona}';
